import Image from "next/image";
import Link from "next/link";

const LoginNavbar = () => {
  return (
    <nav className="flex justify-between px-2% border-b-1 shadow-md h-16 items-center">
      <div className="m-auto w-16 h-11">
        <Link href="/" className="w-16 h-11">
          <Image
            src="/assets/duke.png"
            height={100}
            width={100}
            alt="Duke Logo"
            aria-label="logo"
            priority
            className="w-full h-full"
          />
        </Link>
      </div>
    </nav>
  );
};

export default LoginNavbar;
